import { edgeExists } from './edgeExists';

export function updateEdges(newGraph, networkRef) {
  // Filter new edges to add (batch)
  const edges = networkRef.current.body.data.edges.get();
  const filteredNewEdges = newGraph.edges.filter(edge => !edgeExists(edge, edges));
  if (filteredNewEdges.length > 0) {
    networkRef.current.body.data.edges.add(filteredNewEdges);
  }

  // Remove edges where one of the nodes has been removed (batch)
  const updatedNodeIds = new Set(newGraph.nodes.map(node => node.id));
  const edgesToRemove = edges.filter(edge => {
    return !updatedNodeIds.has(edge.from) || !updatedNodeIds.has(edge.to);
  });
  if (edgesToRemove.length > 0) {
    networkRef.current.body.data.edges.remove(edgesToRemove.map(e => e.id));
  }

  // Reconcile by edge IDs (batch)
  const currentEdges = networkRef.current.body.data.edges.get();
  const currentEdgeIds = new Set(currentEdges.map(edge => edge.id));

  // Find edges to add by ID
  const newEdgeIds = new Set(newGraph.edges.map(edge => edge.id));
  const edgesToAdd = newGraph.edges.filter(edge => !currentEdgeIds.has(edge.id));
  if (edgesToAdd.length > 0) {
    networkRef.current.body.data.edges.add(edgesToAdd);
  }

  // Find edges to remove by ID
  const edgesToRemoveById = currentEdges.filter(edge => !newEdgeIds.has(edge.id));
  if (edgesToRemoveById.length > 0) {
    networkRef.current.body.data.edges.remove(edgesToRemoveById.map(e => e.id));
  }
}
